import { ArrowLeft, ArrowRight, ArrowUp, Search, ChevronRight as BreadcrumbSeparator } from "lucide-react";

interface NavigationProps {
    currentPath: string[];
    onNavigateUp: () => void;
    onNavigateToPathSegment: (index: number) => void;
    searchQuery: string;
    onSearchChange: (query: string) => void;
}

export const Navigation = ({ currentPath, onNavigateUp, onNavigateToPathSegment, searchQuery, onSearchChange }: NavigationProps) => {
    return (
        <div className="bg-gray-200 p-2 flex items-center space-x-2 text-sm">
            <button className="p-1 rounded hover:bg-gray-300 opacity-50 cursor-not-allowed" disabled>
                <ArrowLeft size={20} />
            </button>
            <button className="p-1 rounded hover:bg-gray-300 opacity-50 cursor-not-allowed" disabled>
                <ArrowRight size={20} />
            </button>
            <button
                className={`p-1 rounded hover:bg-gray-300 ${currentPath.length <= 1 ? "opacity-50 cursor-not-allowed" : ""}`}
                onClick={onNavigateUp}
                disabled={currentPath.length <= 1}>
                <ArrowUp size={20} />
            </button>
            <div className="flex-1 bg-white rounded px-2 py-1 flex items-center overflow-x-auto whitespace-nowrap scrollbar-thin scrollbar-thumb-gray-400 scrollbar-track-gray-100">
                {currentPath.map((pathSegment, index) => (
                    <div key={index} className="flex items-center">
                        <button
                            onClick={() => onNavigateToPathSegment(index)}
                            disabled={index === currentPath.length - 1}
                            className={`px-1 py-0.5 rounded ${
                                index === currentPath.length - 1 ? "text-gray-700 font-medium" : "text-blue-600 hover:bg-gray-100"
                            }`}>
                            {pathSegment}
                        </button>
                        {index < currentPath.length - 1 && <BreadcrumbSeparator size={16} className="mx-1 text-gray-400" />}
                    </div>
                ))}
            </div>
            <div className="relative">
                <Search className="absolute left-2 top-1/2 transform -translate-y-1/2 w-4 h-4 text-gray-400" />
                <input
                    type="text"
                    placeholder="Search"
                    value={searchQuery}
                    onChange={(e) => onSearchChange(e.target.value)}
                    className="pl-8 pr-2 py-1 rounded text-sm w-48 border border-gray-300 focus:outline-none focus:ring-1 focus:ring-blue-500"
                />
            </div>
        </div>
    );
};
